import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { ZoneNotes } from '../notes/ZoneNotes';
import { useAuthContext } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';

function ZoneNotesWrapper() {
    const { key } = useLocation();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    return (
        <>
            <DocumentTitle title="Zone Notes"></DocumentTitle>
            <ZoneNotes user={user} refreshIdentifier={key} zoneContext={zoneContext} />
        </>
    );
}

export default ZoneNotesWrapper;
